import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { FiArrowRight } from 'react-icons/fi';
import styles from '../DashboardOverviewNew.module.scss';

const EMPTY_SEGMENT = [{ name: '—', pct: 100, time: '—', color: '#E5E7EB' }];

export const FocusVsDistraction = ({ data, isLoading = false }) => {
  const { focusPct, label, segments } = data || {
    focusPct: 0,
    label: '—',
    segments: EMPTY_SEGMENT,
  };

  return (
    <div
      className={styles.quarterCard}
      style={isLoading ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
    >
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>Focus vs Distraction</span>
      </div>

      <div className={styles.focusWrapper}>
        <div className={styles.focusChartArea}>
          <ResponsiveContainer width={130} height={130}>
            <PieChart>
              <Pie
                data={segments}
                cx="50%"
                cy="50%"
                innerRadius={52}
                outerRadius={62}
                dataKey="pct"
                startAngle={90}
                endAngle={-270}
                strokeWidth={0}
              >
                {segments.map((seg) => (
                  <Cell key={seg.name} fill={seg.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          <div className={styles.focusCenter}>
            <div className={styles.focusCenterValue}>{focusPct}%</div>
            <div className={styles.focusCenterLabel}>{label}</div>
          </div>
        </div>

        <div className={styles.focusLegend}>
          {segments.map((seg) => (
            <div key={seg.name} className={styles.focusLegendItem}>
              <div
                className={styles.legendDot}
                style={{ backgroundColor: seg.color }}
              />
              <span className={styles.focusLegendName}>{seg.name}</span>
              <div className={styles.focusLegendRight}>
                {seg.time}
                <span className={styles.legendRowMeta}> ({seg.pct}%)</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <button className={styles.viewLink}>
        View detailed report <FiArrowRight size={13} />
      </button>
    </div>
  );
};
